export const currentVersion = 8888